module.exports = __webpack_public_path__ + "static/media/ic_bell.4086bced.svg";